export default __webpack_public_path__ + "static/media/scoreboard.505ef1a1.svg";